import React from "react";
import searchIcon from "assets/icons/search.svg";

interface Props {
  border: boolean;
}

export default function SearchField({ border }: Props) {
  return (
    <div
      className={`w-full flex items-center gap-3 bg-[#F9FAFB] h-full px-4 rounded-md ${
        border ? "border border-[#D1D1D1]" : ""
      } `}
    >
      <img src={searchIcon} alt="Search Icon" />
      <input
        type="search"
        placeholder="Search here..."
        className="bg-transparent h-full w-full border-none outline-none text-sm text-[#667185] placeholder:text-sm placeholder:text-[#667185]"
      />
    </div>
  );
}
